import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ExhitorsService {

  constructor(private http: HttpClient) { }


  getPublishedProducts(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_PUBLISHED_PRODUCTS + '/' + dataIn.exhibitorId + '/' + 'publishedProducts';

    return this.http.get(url, dataIn);
  }


  getCategories(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_CATEGORIES + '/' + dataIn.exhibitorId + '/' + 'categories';

    return this.http.get(url, dataIn);
  }


  getProjection(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_PROJECTION + '/' + dataIn.exhibitorId + '?' + 'projection=' + dataIn.projection;

    return this.http.get(url, dataIn);
  }


  getImages(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_IMAGES + '/' + dataIn.exhibitorId + '/' + 'images';

    return this.http.get(url, dataIn);
  }

  createFavoriteExhibitor(dataIn:any):Observable<any> {

    let url = ENV.APP.BACKEND_API + '/catalogueUsers/favorite' + dataIn.type;
    return this.http.post(url, dataIn);

  }

  editFavoriteExhibitor(dataIn:any):Observable<any> {
    let url = ENV.APP.BACKEND_API + '/catalogueUsers/favoriteExhibitor';
    return this.http.put(url, dataIn);

  }
  
  editFavoriteProduct(dataIn:any):Observable<any> {
    let url = ENV.APP.BACKEND_API + '/catalogueUsers/favoriteProduct';
    return this.http.put(url, dataIn);

  }

  deleteFavoriteExhibitor(favoriteId:number):Observable<any> {
    let url = ENV.APP.BACKEND_API + '/catalogueUsers/favoriteExhibitor/' + favoriteId;
    return this.http.delete(url);

  }

  deleteFavoriteProduct(favoriteId:number):Observable<any> {
    let url = ENV.APP.BACKEND_API + '/catalogueUsers/favoriteProduct/' + favoriteId;
    return this.http.delete(url);

  }

  /*
    EXAMPLE URL: https://ecataloguestg-api.cwsfirabarcelona.com/v1/exhibitors/199198/mainImageUrl?language=es_ES
  */
  getExhibitorMainImageUrl(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_EXHIBITOR_MAIN_IMAGE_URL + '/' + dataIn.exhibitorId + '/' + 'mainImageUrl';

    return this.http.get(url, dataIn);
  }

  getStatuses() {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_STATUSES;

    return this.http.get(url);

  }

  getProducts(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_PRODUCTS + '/' + dataIn.exhibitorId + '/products?projection=productlist';

    return this.http.get(url);

  }


  saveExhibitor(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.SAVE_EXHIBITOR;

    return this.http.put(url, dataIn);

  }

  getExhibitor(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_EXHIBITOR + '/' + dataIn.exhibitorId;

    return this.http.get(url);

  }

  getExhibitorSector(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_EXHIBITOR_SECTOR + '/' + dataIn.exhibitorId + '/sector';

    return this.http.get(url);

  }

  getExhibitorCataloguePlan(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_EXHIBITOR_CATALOGUE_PLAN + '/' + dataIn.exhibitorId + '/cataloguePlan?projection=onlyLimits';

    return this.http.get(url);

  }

  getImportableExhibitor(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHITORS.GET_IMPORT_EXHIBITOR + '/' + dataIn.exhibitorId + '/getImportableExhibitor?sapId=' + dataIn.sapId;

    return this.http.get(url);
  }


  
  editCopyExhibitorAndProducts(id: number, data: any):Observable<any> {
    
    let url = ENV.APP.BACKEND_API + `/exhibitors/${id}/copy`;
    
    return this.http.put(url, data);

  }


}
